import { SelectedMedia } from '@pletly/common';

import { FileType } from '%__generated__/types';

export const mapMediaForOptimisticResponse = (
	selectedMedia: SelectedMedia[],
	timestamp: number,
) => {
	return selectedMedia.map((selectedImage, imageIndex) => ({
		id: selectedImage.id || `temp-id-${timestamp}-${imageIndex}`,
		__typename: 'File' as const,
		type: (selectedImage.type as FileType) || FileType.Image,
		url: selectedImage.uri,
		blurhash: selectedImage.blurhash || null,
		thumbnailUrl: null,
		thumbnailBlurhash: null,
		name: selectedImage.file?.name || '',
	}));
};

export const mapSelectedUsersForOptimisticResponse = (
	selectedUsersIds?: string[] | string | null,
) => {
	if (!selectedUsersIds) {
		return null;
	}

	const selectedUsers = Array.isArray(selectedUsersIds) ? selectedUsersIds : [selectedUsersIds];

	return selectedUsers.map((userId) => ({
		__typename: 'PostAccess' as const,
		user: { __typename: 'User' as const, id: userId },
	}));
};
